import { useState } from 'react';
import { Dropdown } from 'antd';

import Settings04Icon from 'assets/svg/Settings04Icon';

import { ppaSimTableColumnFilterBtnTestId, ppaSimTableColumnHeaderTestId } from 'constants/ppaTestIds';
import type { SimulationColumnFilterSortConfig } from 'types/ppaSimulationMeta';
import ColumnFilterSortPanel, { type ColumnFilterSortValue } from './ColumnFilterSortPanel';

type ColumnFilterSortHeaderProps = {
    columnKey: string;
    title: string;
    options: string[];
    value: ColumnFilterSortValue;
    labels: SimulationColumnFilterSortConfig;
    onApply: (value: ColumnFilterSortValue) => void;
};

const FILTER_SORT_DROPDOWN_OVERLAY_STYLE = {
    padding: 0,
    background: 'transparent',
    boxShadow: 'none',
};

const ColumnFilterSortHeader = ({
    columnKey,
    title,
    options,
    value,
    labels,
    onApply,
}: ColumnFilterSortHeaderProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleCancel = () => {
        setIsOpen(false);
    };

    const handleApply = (nextValue: ColumnFilterSortValue) => {
        onApply(nextValue);
        setIsOpen(false);
    };

    return (
        <div className="flex w-full items-center justify-between gap-2" data-testid={ppaSimTableColumnHeaderTestId(columnKey)}>
            <span className="truncate text-left text-[12px] font-semibold leading-[18px]">{title}</span>
            <Dropdown
                trigger={['click']}
                open={isOpen}
                onOpenChange={setIsOpen}
                placement="bottomRight"
                overlayClassName="column-filter-sort-dropdown"
                overlayStyle={FILTER_SORT_DROPDOWN_OVERLAY_STYLE}
                destroyPopupOnHide
                getPopupContainer={() => document.body}
                dropdownRender={() => (
                    <ColumnFilterSortPanel
                        columnKey={columnKey}
                        options={options}
                        value={value}
                        labels={labels}
                        onCancel={handleCancel}
                        onApply={handleApply}
                    />
                )}
            >
                <button
                    type="button"
                    className={`column-filter-sort-trigger inline-flex size-5 shrink-0 items-center justify-center rounded-[4px]${
                        isOpen ? ' is-open' : ''
                    }${value.sortOrder ? ' is-sorted' : ''}`}
                    aria-label={`Filter and sort ${title}`}
                    data-testid={ppaSimTableColumnFilterBtnTestId(columnKey)}
                    onClick={(event) => event.stopPropagation()}
                >
                    <Settings04Icon />
                </button>
            </Dropdown>
        </div>
    );
};

export default ColumnFilterSortHeader;
